import {Loader} from '@googlemaps/js-api-loader';

/**
 * The browser Maps key, from configuration (REACT_APP_GOOGLE_MAPS_API_KEY in
 * .env, overridable per environment like every REACT_APP_ value). It is a
 * referrer-restricted browser key, so it is public by design; it just should
 * not be written into each map's code.
 */
export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY ?? '';

let loader: Loader | undefined;

/** The one Maps loader: the library refuses a second Loader with different options. */
export const googleMapsLoader = (): Loader => {
  loader ??= new Loader({apiKey: GOOGLE_MAPS_API_KEY, version: 'beta'});
  return loader;
};
